import { forDesktop, forTablet } from '@westwing/ui-kit/breakPoints';
import styled, { css } from 'styled-components';

interface SkeletonProps {
    height?:
        | string
        | {
              base: string;
              tablet?: string;
              desktop?: string;
          };
    backgroundColor?: string;
}

const Skeleton = styled.div
    .withConfig({
        shouldForwardProp: prop => !['height', 'backgroundColor'].includes(prop),
    })
    .attrs<SkeletonProps>(props => ({
        'aria-busy': true,
        height: props.height || '100vh',
        backgroundColor: props.backgroundColor || props.theme.colors.white,
    }))<SkeletonProps>`
    
    ${({ height }) => {
        if (typeof height === 'object') {
            return css`
                height: ${height.base};

                ${forTablet`
                    height: ${height['tablet' || 'base']};
                `}

                ${forDesktop`
                    height: ${height['desktop' || 'base']};
                `}
            `;
        }
        return css`
            height: ${height};
        `;
    }}
    
    width: 100%;
    background: ${({ backgroundColor }) => backgroundColor};
`;

export default Skeleton;
